import { useContext } from 'react'
import { ViewerContext } from 'contexts/ViewerContext'
import { Heading } from '@careguide/typography'
import Stack from '@careguide/stack'
import { Description } from './ListingDescription.styles'

type ListingDescriptionProps = {
  description: string
  loggedInDescriptionHeading: string
  loggedOutDescriptionHeading: string
}

const ListingDescription = ({
  description,
  loggedInDescriptionHeading,
  loggedOutDescriptionHeading,
}: ListingDescriptionProps) => {
  const viewer = useContext(ViewerContext)
  const isUserLoggedIn = !!viewer?.user?.userId
  const headingText = isUserLoggedIn ? loggedInDescriptionHeading : loggedOutDescriptionHeading

  return (
    <Stack gap='4'>
      <Heading as='h1'>{headingText}</Heading>
      <Description>{description}</Description>
    </Stack>
  )
}

export default ListingDescription
